module.exports = __webpack_public_path__ + "static/img/7.ad2984a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/7.png
// module id = xWUk
// module chunks = 0